import { User_Bool_Exp } from "@/generated/graphql";

const getInboxMultiselectManagerConditions = (userId: string, companyId: string): User_Bool_Exp => {
  return {
    "_or": [
      {
        "_and": [
          {
            "role": {
              "_neq": "MANAGER"
            }
          },
          {
            "_or": [
              {
                "admin": {
                  "company": {
                    "managers": {
                      "user_id": {
                        "_eq": userId
                      }
                    }
                  }
                }
              },
              {
                "contracts": {
                  "managers": {
                    "manager": {
                      "user_id": {
                        "_eq": userId
                      }
                    }
                  }
                }
              },
              {
                "contracts": {
                  "company": {
                    "managers": {
                      "user_id": {
                        "_eq": userId,
                      }
                    }
                  }
                }
              },
              {
                "conversations": {
                  "conversation": {
                    "users": {
                      "_and": [
                        {
                          "deleted": {
                            "_eq": false
                          }
                        },
                        {
                          "user_id": {
                            "_eq": userId
                          }
                        }
                      ]
                    }
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  };
};

const getInboxMultiselectAdminConditions = (userId: string, companyId: string): User_Bool_Exp => {
  return {
    "_and": [
      {
        "role": {
          "_neq": "ADMIN"
        }
      },
      {
        "_or": [
          {
            "manager": {
              _and: [
                {
                  "company": {
                    "admins": {
                      "user_id": {
                        "_eq": userId
                      }
                    }
                  }
                },
                {
                  "_or": [
                    {
                      "status": {
                        "_is_null": true
                      }
                    },
                    {
                      "status": {
                        "_neq": "SUSPENDED"
                      }
                    }
                  ]
                }
              ]
            }
          },
          {
            "_and": [
              {
                "role": {
                  "_eq": "CONTRACTOR"
                },
                "_or": [
                  // {
                  //   "marketplace": {
                  //     "_eq": false
                  //   },
                  // },
                  {
                    "contracts": {
                      "_and": [
                        {
                          "company": {
                            "admins": {
                              "user_id": {
                                "_eq": userId,
                              }
                            }
                          }
                        },
                        {
                          "deleted": {
                            "_eq": false,
                          },
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  };
};

export {
  getInboxMultiselectManagerConditions,
  getInboxMultiselectAdminConditions,
};